var _path, _circle, _path2, _circle2, _path3, _circle3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1f22",
    d: "M59.998 55.563 3.834 32.519 59.998 9.475l.73 1.78L8.904 32.519l51.824 21.264z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.699,
    cy: 13.064,
    r: 9.433,
    fill: "#1b1f22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1f22",
    d: "M52.7 23.459a10.395 10.395 0 1 1 10.394-10.395A10.407 10.407 0 0 1 52.7 23.459m0-18.866a8.47 8.47 0 1 0 8.47 8.47 8.48 8.48 0 0 0-8.47-8.47"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.699,
    cy: 51.974,
    r: 9.433,
    fill: "#1b1f22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1f22",
    d: "M52.7 62.37a10.395 10.395 0 1 1 10.394-10.396A10.406 10.406 0 0 1 52.7 62.37m0-18.867a8.47 8.47 0 1 0 8.47 8.471 8.48 8.48 0 0 0-8.47-8.47"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.841,
    cy: 32.519,
    r: 9.433,
    fill: "#1b1f22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1f22",
    d: "M10.842 42.914a10.395 10.395 0 1 1 10.394-10.395 10.407 10.407 0 0 1-10.394 10.395m0-18.865a8.47 8.47 0 1 0 8.47 8.47 8.48 8.48 0 0 0-8.47-8.47"
  })));
};
export default SvgShare;